module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "readonly": "",
      "prepend-icon": _vm.icon,
      "single-line": "",
      "label": _vm.label,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus($event)
      }
    },
    model: {
      value: (_vm.filename),
      callback: function($$v) {
        _vm.filename = $$v
      },
      expression: "filename"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('bottom-sheet', {
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('v-list', [_c('v-subheader', [_vm._v("Escolher uma ação")]), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.androidCamera
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("photo_camera")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Câmera")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.androidLibrary
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("photo_library")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Biblioteca de Fotos")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3561f683"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/FileInput.vue
// module id = 1005
// module chunks = 1